import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ConfiguratorActionBarStep } from '@obo-main/components/configurator/configuratorActionBar/configuratorActionBarStep.model';
import { Constants } from '@obo-app/constants';
import { StateService } from '@uirouter/core';
import { AuthService } from '@obo-main/services/auth/auth.service';

@Injectable()
export class ConfiguratorActionBarService {
    private _currentStep: Subject<ConfiguratorActionBarStep> = new Subject<ConfiguratorActionBarStep>();
    private _steps: Subject<ConfiguratorActionBarStep[]> = new Subject<ConfiguratorActionBarStep[]>();
    private _projectId: number;
    private _showReview: Subject<{
        icon: string;
        name: string;
        locked: boolean;
        completed: boolean;
        target: HTMLElement;
    }> = new Subject<{
        icon: string;
        name: string;
        locked: boolean;
        completed: boolean;
        target: HTMLElement;
    }>();
    private _closeReview: Subject<void> = new Subject<void>();
    private _closeOverlay: Subject<void> = new Subject<void>();

    constructor(private stateService: StateService, private authService: AuthService) {}

    public set currentStep(step: ConfiguratorActionBarStep) {
        this._currentStep.next(step);
    }

    public set steps(steps: ConfiguratorActionBarStep[]) {
        this._steps.next(steps);
    }

    public get currentStep(): Observable<ConfiguratorActionBarStep> {
        return this._currentStep.asObservable();
    }

    public get steps(): Observable<ConfiguratorActionBarStep[]> {
        return this._steps.asObservable();
    }

    public set projectId(projectId: number) {
        this._projectId = projectId;
    }

    public get projectId(): number {
        return this._projectId;
    }

    public showReview(icon: string, name: string, locked: boolean, completed: boolean, target: HTMLElement): Observable<void> {
        this._showReview.next({ icon: icon, name: name, locked: locked, completed: completed, target: target });
        return this.onCloseOverlay();
    }

    public onShowReview(): Observable<{ icon: string; name: string; target: HTMLElement }> {
        return this._showReview.asObservable();
    }

    public closeReview(): void {
        this._closeReview.next();
    }

    public closeOverlay(): void {
        this._closeOverlay.next();
    }

    public onCloseReview(): Observable<void> {
        return this._closeReview.asObservable();
    }

    public onCloseOverlay(): Observable<void> {
        return this._closeOverlay.asObservable();
    }

    public cancel(): void {
        if (this.isGuest) {
            this.stateService.go('portal');
        } else if (!this.projectId) {
            this.stateService.go('dashboard');
        } else {
            this.stateService.go('project', { projectId: this.projectId });
        }
    }

    private get isGuest(): boolean {
        return this.authService.isInRole([Constants.Role.Guest]);
    }
}
